import React, { Component } from 'react';
import { dateHelper, lessonSectionService, stringHelper } from 'libs';
import { Button } from 'design-react-kit';

export class AnalyticsProgressBar extends Component {

  /**
   * 
   * per attivarte questo componetne inserire il valore "metadata.showAnalytic=true" del record "course"
   */
  constructor(props) {
    super(props);

    this.state = {
      showAnalytics: false,
      metadata: this.props.metadata,
      analytic: {
        currentPercentage: 0,
        lastUpdate: 0,
        estimatedPercentage: 0,
      }
    };
  }

  componentDidMount() {  
    if (this.props.showAnalytics) {
     this.setState({ showAnalytics: true });
    this.loadAnalytics();
    }
  }

  showAnalytics(e) {
    e.preventDefault();
    this.setState({ showAnalytics: true });
    this.loadAnalytics();
  }

  loadAnalytics() {

    if (this.props.rCode === undefined) return false;

    lessonSectionService
      .getAnalyticStudentTFAIndire(this.props.rCode)
      .then(({ data }) => {
        if (data && data.payload) {
          this.setState({
            analytic: {
              ...this.state.analytic,
              ...data.payload
            }
          });
        }
      })
      .catch(error => {
        console.error("Error fetching analytics data:", error);
      });

  }


  render() {
    const { analytic, showAnalytics } = this.state;
    const current = 1 - analytic.currentPercentage;
    const estimated = 1 - analytic.estimatedPercentage;

    const lastUpdate =analytic.lastUpdate ? dateHelper.toITDateTime(analytic.lastUpdate):'';
    
    return (
      <>
        {showAnalytics ? (
          <>
            <ul>
              <li>Percentuale di assenza sulle attività {(lastUpdate) && (<>erogate alla data del <b>{lastUpdate}</b></>)}: <b>{stringHelper.formatPercentage(current)}</b></li>
              <li>Percentuale di assenza complessiva stimata (ipotizzando una partecipazione al 100% alle attività dal <b>{lastUpdate}</b> fino al termine del corso): <b>{stringHelper.formatPercentage(estimated)}</b></li>
            </ul>
            <p>Si ricorda che, ai fini dell'ammissione all'esame finale, la percentuale massima di assenze consentita è pari al 10% del monte ore complessive su tutto il percorso formativo (cioè sul 100% delle attività) ovvero la percentuale riportata al precedente punto b).</p>
          </>
        ) : (
          <div> 
            <Button
            className="ml-2"
            color="primary"
            outline
            onClick={(e) => {
              this.showAnalytics(e);
            }}
          >
            <span className="d-button-label">Mostra percentuale assenza</span>
          </Button></div>)}
      </>
    );
  }
}